export default __webpack_public_path__ + "static/media/Media-Analyst-Briefing-Note.3a373dfb.pdf";